<template>
	<div class="serial-wrap">
		<div class="condition-node">
			<div class="condition-node-box">
				<div class="auto-judge" @click="(v)=>$emit('node-click',_config)">
					<div class="sort-left" v-if="_index!==0" @click.stop="$emit('to-left',_index)">
						<el-icon>
							<el-icon-arrow-left/>
						</el-icon>
					</div>
					<div class="title">
						<span class="node-title">{{ _define.title }}</span>
						<span class="priority-title">优先级{{ _index + 1}}</span>
						<el-icon class="close" @click.stop="$emit('del-node',_config)">
							<el-icon-close/>
						</el-icon>
					</div>
					<div class="content">
						<span v-if="_config.description">{{ _config.description }}</span>
						<span v-else class="placeholder">请设置条件</span>
					</div>
					<div class="sort-right" v-if="_index!==_parent.children?.length-1" @click.stop="$emit('to-right',_index)">
						<el-icon>
							<el-icon-arrow-right/>
						</el-icon>
					</div>
				</div>
				<add-action :nodes="define.nodes||[]" @add-node="(name)=>handleAddNode(-1,name)"></add-action>
			</div>
		</div>
		<flow-render v-for="(item,index) in _config.children" :_config="item" :_parent="_config"
					 :key="item.id||index"
					 :_index="index" @add-node="(name)=>handleAddNode(index,name)" @node-click="(v)=>$emit('node-click',v)"></flow-render>
	</div>

</template>

<script>
import FlowRender from "@/components/flow/flow-render.vue";
import FlowAction from "@/components/flow/nodes/flow-action.vue";
import AddAction from "@/components/flow/nodes/flow-action.vue";
import {getFlow} from "@/components/flow/flow-context";

export default {
	components: {AddAction, FlowAction, FlowRender},
	props: {
		_config: {
			type: Object
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_define: {
			type: Object, default: () => ({})
		},
		_index: {
			type: Number
		}
	},
	setup(props) {
		const handleAddNode = (index, node) => {
			props._config.children.splice(index + 1, 0, Object.assign(node.default() || {}, {
				name: node.name,
			}))
		}
		const define = getFlow(props._config.name)
		return {
			define,
			handleAddNode
		}
	}
}
</script>

<style lang="scss" scoped>
.serial-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.condition-node {
	display: inline-flex;
	flex-direction: column;
	min-height: 220px;
}

.condition-node-box {
	padding-top: 30px;
	padding-right: 50px;
	padding-left: 50px;
	justify-content: center;
	align-items: center;
	flex-grow: 1;
	position: relative;
	display: inline-flex;
	flex-direction: column;
}

.condition-node-box::before {
	content: "";
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	margin: auto;
	width: 2px;
	height: 100%;
	background-color: rgb(202, 202, 202);
}

.auto-judge {
	position: relative;
	width: 220px;
	min-height: 72px;
	background: rgb(255, 255, 255);
	border-radius: 4px;
	padding: 15px 15px;
	cursor: pointer;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
}

.auto-judge::before {
	content: "";
	position: absolute;
	top: -12px;
	left: 50%;
	transform: translateX(-50%);
	width: 0px;
	border-style: solid;
	border-width: 8px 6px 4px;
	border-color: rgb(202, 202, 202) transparent transparent;
	background: rgb(245, 245, 247);
}

.auto-judge .title {
	line-height: 16px;
}

.auto-judge .title .node-title {
	color: #15BC83;
}

.auto-judge .title .close {
	font-size: 15px;
	position: absolute;
	top: 15px;
	right: 15px;
	color: #999;
	display: none;
}

.auto-judge .title .priority-title {
	position: absolute;
	top: 15px;
	right: 15px;
	color: #999;
}

.auto-judge .content {
	position: relative;
	padding-top: 15px;
}

.auto-judge .content .placeholder {
	color: #999;
}

.auto-judge:hover {
	.close {
		display: block;
	}

	.priority-title {
		display: none;
	}
}

.auto-judge .sort-left {
	position: absolute;
	top: 0;
	bottom: 0;
	z-index: 1;
	left: 0;
	display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.auto-judge .sort-right {
	position: absolute;
	top: 0;
	bottom: 0;
	z-index: 1;
	right: 0;
	display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.auto-judge .sort-left:hover, .auto-judge .sort-right:hover {
	background: #eee;
}

.auto-judge:after {
	pointer-events: none;
	content: "";
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	border-radius: 4px;
	transition: all .1s;
}

.auto-judge:hover:after {
	border: 1px solid #3296fa;
	box-shadow: 0 0 6px 0 rgba(50, 150, 250, .3);
}

.auto-judge:hover .sort-left, .auto-judge:hover .sort-right {
	display: flex;
}
</style>
